import { useEffect, useRef, useState, type FormEvent } from 'react';
import { api } from '../api';
import { ApiError } from '../api/types';
import { t } from '../i18n/idioma';
import { useFechar } from '../input/useAtalhos';
import { Gump } from './Gump';

interface Props {
  name: string;
  onCancel(): void;
  onSent(): void;
}

export function ReportModal({ name, onCancel, onSent }: Props) {
  const [reason, setReason] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);
  const area = useRef<HTMLTextAreaElement>(null);
  const ready = reason.trim().length >= 10;

  useFechar(onCancel, { modal: true });
  useEffect(() => { area.current?.focus(); }, []);

  const submit = async (e: FormEvent) => {
    e.preventDefault();
    if (!ready || busy) return;
    setError(null);
    setBusy(true);
    try {
      await api.reportPlayer(name, reason);
      onSent();
    } catch (err) {
      setError(err instanceof ApiError ? err.message : t('denuncia.naoEnviou'));
      setBusy(false);
    }
  };

  return (
    <div className="modal" role="presentation" onClick={onCancel}>
      <div role="dialog" aria-modal="true" aria-labelledby="report-title" onClick={e => e.stopPropagation()}>
        <Gump
          title={t('denuncia.titulo')}
          action={
            <button type="button" className="btn btn--tiny btn--ghost" onClick={onCancel} aria-label={t('comum.fechar')}>
              ×
            </button>
          }
        >
          <form className="stack" onSubmit={e => void submit(e)}>
            <p id="report-title">{t('denuncia.denunciarNome', { nome: name })}</p>
            <label className="field">
              <span className="field__label">{t('denuncia.querMotivo')}</span>
              <textarea
                ref={area}
                value={reason}
                onChange={e => setReason(e.target.value)}
                maxLength={400}
                rows={4}
                placeholder={t('denuncia.contexto')}
                disabled={busy}
              />
            </label>
            <p className="muted">
              {t('denuncia.aviso')}
            </p>
            {error && <p className="notice" role="alert">{error}</p>}
            <div className="row row--split">
              <span />
              <button type="submit" className="btn btn--danger" disabled={!ready || busy}>
                {busy ? t('comum.enviando') : t('denuncia.enviarDenuncia')}
              </button>
            </div>
          </form>
        </Gump>
      </div>
    </div>
  );
}
